import { Fragment, useState } from "react";
import Header from "../components/global/Header";
import Sidebar from "../components/global/SideBar";
import AdminLayoutProps from "../services/models/adminLayoutProps.model";

function AdminLayout({ children }: Readonly<AdminLayoutProps>): JSX.Element {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="grid grid-rows-twoRowLayout h-[100vh] overflow-auto lg:overflow-hidden">
      <Header toggleMobileMenu={toggleMobileMenu} closeMobileMenu={closeMobileMenu} />
      <div className="grid grid-cols-1 lg:grid-cols-twoColumnLayout overflow-hidden h-full">
        <Sidebar
          toggleMobileView={toggleMobileMenu}
          isOpen={mobileMenuOpen}
          containerClassName="xs:hidden md:block"
        />
        {children}
      </div>
      <div
        className={`md:hidden absolute transition-all duration-300 ease-in-out top-[58px] left-0 ${mobileMenuOpen
            ? "translate-x-0 opacity-100"
            : "-translate-x-full invisible opacity-0"
          } h-[calc(100vh_-_57px)] w-[60vw] bg-white z-[9999999]`}
      >
        <Sidebar
          toggleMobileView={toggleMobileMenu}
          closeMobileMenu={closeMobileMenu}
          isOpen={mobileMenuOpen}
          containerClassName="xs:flex xs:flex-col h-full xs:justify-between z-[9999999]"
        />
      </div>
    </div>
  );
}

export default AdminLayout;
